module.exports = __webpack_public_path__ + "img/workout5.92c64cbc.jpg";